<template>
    <el-button type="primary" :size="size"  :disabled="ids.length < 1" @click="doClick">
      <slot></slot>
    </el-button>
</template>
<script>
export default {
  name:"LyButtonBatch",
  props: {
    config: {
      type: Object,
      default: () => {}
    }, // 备注提交的地址
    rows: { // 要备注列的数据集合
      type: Array,
      default: () => []
    },            
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
      ids () {
          let id = []
          this.rows.forEach((el) => {
              if (el.id) {
                  id.push(el.id)
              }
          })
          return id
      }
  },
  methods: {
    doClick () {
        this.$confirm(this.config.json.confirm, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: action => {
                if (action === 'confirm') {
                    this.$api[this.config.json.method](this.config.json.api, {
                        ids: this.ids
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: this.config.name + '完成'
                        })
                        this.$emit('operDone')
                    }).catch((msg) => {
                        this.$message({
                            type: 'warning',
                            message: msg
                        })
                    })
                }
            }
        })
    }
  }
}
</script>